import React, { useState } from "react";
import axios from "axios";
import { CURTAINS, curtainCommand } from "../data/devices";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "https://test-automation.graymatrix.com:9443";

const ACTIONS = [
  { key: "open",  label: "Open",  color: "#c8a84b", textColor: "#0a0a0a" },
  { key: "close", label: "Close", color: "transparent", border: "1px solid rgba(139,53,53,0.5)", textColor: "#9b5050" },
  { key: "stop",  label: "Stop",  color: "transparent", border: "1px solid #2c2c2c", textColor: "#666" },
];

function CurtainRow({ curtain }) {
  const [status, setStatus] = useState("idle"); // idle | loading | ok | error
  const [activeAction, setActiveAction] = useState(null);

  async function handleAction(action) {
    setStatus("loading");
    setActiveAction(action);
    const command = curtainCommand(curtain.ip, curtain.mac, action);
    try {
      await axios.post(`${BACKEND_URL}/`, { command });
      setStatus("ok");
    } catch (err) {
      console.error(err);
      setStatus("error");
    }
    setTimeout(() => { setStatus("idle"); setActiveAction(null); }, 2000);
  }

  return (
    <div style={{
      background: "#181818",
      border: "1px solid #2c2c2c",
      borderRadius: 10,
      padding: "14px 20px",
      marginBottom: 10,
      display: "flex",
      alignItems: "center",
      gap: 16,
      flexWrap: "wrap",
    }}>
      {/* Name */}
      <div style={{ flex: 1, minWidth: 120 }}>
        <div style={{ fontSize: 14, fontWeight: 600, color: "#eaeaea" }}>{curtain.name}</div>
        <div style={{ fontSize: 11, color: "#444", marginTop: 2 }}>{curtain.ip}</div>
        {status === "ok"    && <div style={{ fontSize: 11, color: "#3a6b4a", marginTop: 2 }}>Command sent</div>}
        {status === "error" && <div style={{ fontSize: 11, color: "#9b5050", marginTop: 2 }}>Failed</div>}
      </div>

      {/* Buttons */}
      <div style={{ display: "flex", gap: 8 }}>
        {ACTIONS.map(({ key, label, color, border, textColor }) => (
          <button
            key={key}
            disabled={status === "loading"}
            onClick={() => handleAction(key)}
            style={{
              padding: "7px 18px",
              background: status === "loading" && activeAction === key ? "#2a2a2a" : color,
              color: status === "loading" && activeAction === key ? "#555" : textColor,
              border: border || "none",
              borderRadius: 7,
              fontWeight: 700,
              fontSize: 13,
              cursor: status === "loading" ? "not-allowed" : "pointer",
              letterSpacing: "0.2px",
              transition: "opacity 0.15s",
              minWidth: 64,
            }}
          >
            {label}
          </button>
        ))}
      </div>
    </div>
  );
}

export default function CurtainsPage() {
  const [allStatus, setAllStatus] = useState("idle");

  async function handleAll(action) {
    setAllStatus("loading");
    try {
      for (const c of CURTAINS) {
        const command = curtainCommand(c.ip, c.mac, action);
        await axios.post(`${BACKEND_URL}/`, { command });
        await new Promise(r => setTimeout(r, 100));
      }
      setAllStatus("ok");
    } catch {
      setAllStatus("error");
    }
    setTimeout(() => setAllStatus("idle"), 3000);
  }

  return (
    <div style={{ maxWidth: 700, margin: "0 auto", padding: "8px 4px 40px" }}>
      {/* Header */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 24 }}>
        <h2 style={{ margin: 0, fontSize: "1.4rem", fontWeight: 700, color: "#c8a84b", letterSpacing: "0.3px" }}>
          Curtains
        </h2>
        {/* Master controls */}
        <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
          {allStatus === "ok"    && <span style={{ fontSize: 12, color: "#3a6b4a" }}>Done</span>}
          {allStatus === "error" && <span style={{ fontSize: 12, color: "#9b5050" }}>Failed</span>}
          <button
            disabled={allStatus === "loading"}
            onClick={() => handleAll("open")}
            style={{ padding: "7px 14px", background: "#c8a84b", color: "#0a0a0a", border: "none", borderRadius: 7, fontWeight: 700, fontSize: 12, cursor: allStatus === "loading" ? "not-allowed" : "pointer" }}
          >
            All Open
          </button>
          <button
            disabled={allStatus === "loading"}
            onClick={() => handleAll("close")}
            style={{ padding: "7px 14px", background: "transparent", color: "#9b5050", border: "1px solid rgba(139,53,53,0.4)", borderRadius: 7, fontWeight: 700, fontSize: 12, cursor: allStatus === "loading" ? "not-allowed" : "pointer" }}
          >
            All Close
          </button>
          <button
            disabled={allStatus === "loading"}
            onClick={() => handleAll("stop")}
            style={{ padding: "7px 14px", background: "transparent", color: "#666", border: "1px solid #2c2c2c", borderRadius: 7, fontWeight: 700, fontSize: 12, cursor: allStatus === "loading" ? "not-allowed" : "pointer" }}
          >
            All Stop
          </button>
        </div>
      </div>

      {/* Individual curtains */}
      {CURTAINS.map(c => <CurtainRow key={c.ip} curtain={c} />)}

      <p style={{ fontSize: 11, color: "#333", marginTop: 20, textAlign: "center" }}>
        If a curtain moves in the wrong direction, swap Open and Close.
      </p>
    </div>
  );
}
